export const generateAPI_Id = (multiplier, minValue = 0) => ~~(Math.random() * multiplier) + minValue
export const generateId = () => Math.random().toString(36).toString(36).substr(2, 9)
export const firstLetToUpperCase = str => str.charAt(0).toUpperCase() + str.slice(1)

export const imgUrlGenerate = (imgName, publicFolder = `/img/`) => `${process.env.PUBLIC_URL}${publicFolder}${imgName}`
